/**
 * Phase 6e2c-0 — PARKED VENDOR TAB placeholder (§32 + §53.3).
 *
 * The 6 vendor selectors (fan / coil / energy_wheel / plate_heat_exchanger /
 * gas_heater / uvc) are NOT ported in this phase — their /rating/ vendor
 * dispatch stays legacy/parked. The chassis still needs a complete tab body so
 * the dialog is structurally whole; this renders a clearly-labelled placeholder
 * (no functionality, no legacy view loaded, no network calls). It is intentional
 * — see the registry note — not a missing port.
 */

interface ParkedVendorPlaceholderProps {
  label: string;
}

export const ParkedVendorPlaceholder = ({ label }: ParkedVendorPlaceholderProps) => (
  <div className="parked-vendor-selector">
    <p>
      <strong>{label}</strong> rating is handled on the classic board.
    </p>
    <p className="small-text">
      This selector has not yet been migrated to the new board.
    </p>
  </div>
);
